import React from 'react';

const PrivacyPolicy = () => (
  <main className="bg-white min-h-screen py-12">
    <div className="container mx-auto px-4 max-w-3xl">
      <h1 className="text-3xl md:text-4xl font-bold mb-6 text-primary">Privacy Policy</h1>
      <p className="text-dark leading-relaxed mb-4">
        We value your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our website. We do not share your personal information with third parties except as required by law or to provide our services. By using our website, you consent to our privacy practices as described here.
      </p>
      <h2 className="text-2xl font-bold mb-2 mt-8 text-primary">Information Collection</h2>
      <p className="text-dark leading-relaxed mb-4">
        We may collect personal information such as your name, email address, and phone number when you contact us or make a donation. This information is used solely for communication and record-keeping purposes.
      </p>
      <h2 className="text-2xl font-bold mb-2 mt-8 text-primary">Cookies</h2>
      <p className="text-dark leading-relaxed mb-4">
        Our website may use cookies to enhance your browsing experience. You can disable cookies in your browser settings if you prefer.
      </p>
      <h2 className="text-2xl font-bold mb-2 mt-8 text-primary">Contact</h2>
      <p className="text-dark leading-relaxed">
        If you have any questions about this Privacy Policy, please contact us at <a href="mailto:jivadayamandalbhachau@yahoo.com" className="text-blue-500 underline">jivadayamandalbhachau@yahoo.com</a>.
      </p>
    </div>
  </main>
);

export default PrivacyPolicy;
